import { render, staticRenderFns } from "./RouteWrapper.vue?vue&type=template&id=2985eeee"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2985eeee')) {
      api.createRecord('2985eeee', component.options)
    } else {
      api.reload('2985eeee', component.options)
    }
    module.hot.accept("./RouteWrapper.vue?vue&type=template&id=2985eeee", function () {
      api.rerender('2985eeee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RouteWrapper.vue"
export default component.exports